var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "109.6%",
    height: "115.3%",
    x: "-3.9%",
    y: "-6.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h1108v691H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-523-51H689V1H-523z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M-522.5 1.5h1263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-523 3H689v52H-523z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#4A4A4A",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    transform: "translate(-523 3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 504,
    y: 29
  }, "Lorem ipsum dolor\u2026")), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "M-652-460H788V565H-652z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-486 -292)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.667h-.833V1H14.5v1.667H6.167V1H4.5v1.667h-.833C2.75 2.667 2 3.417 2 4.333v13.334c0 .916.75 1.666 1.667 1.666H17c.917 0 1.667-.75 1.667-1.666V4.333c0-.916-.75-1.666-1.667-1.666zm0 15H3.667V8.5H17v9.167zm0-10.834H3.667v-2.5H17v2.5z",
    fill: "#1565C0",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar-blue.568e35e8b98cccf330a12de78aad80be.svg";
export { ForwardRef as ReactComponent };